<template>
  <b-container fluid style="max-width:1200px;">
    <b-row style="margin-top: 5em; margin-bottom: 1em">
      <b-col>
        <h2 class="text-secondary">
          <i>{{
            $t("globals.permissions") +
              " " +
              $t("globals.for") +
              " " +
              user.firstname +
              " " +
              user.lastname
          }}</i>
        </h2>
      </b-col>
      <b-col>
        <h4 class="text-secondary float-right mt-2">
          {{ user.email }}
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs>
          <b-tab title="ULU">
            <!-- Ulu permissions -->
            <ulu-brand-permissions
              :permissions="permissions.ulu"
              :updatePermissions="updateUluPermissions"
              :reloadUser="fetchUser"
              brand="ulu"
            />
          </b-tab>
          <b-tab title="Cartracker">
            <!-- Cartractker permissions -->
            <ulu-brand-permissions
              :permissions="permissions.cartracker"
              :updatePermissions="updateCartrackerPermissions"
              :reloadUser="fetchUser"
              brand="cartracker"
            />
          </b-tab>
          <b-tab title="Fleetify">
            <!-- Fleetify permissions -->
            <ulu-brand-permissions
              :permissions="permissions.fleetify"
              :updatePermissions="updateFleetifyPermissions"
              :reloadUser="fetchUser"
              brand="fleetify"
            />
          </b-tab>
          <b-tab title="ULU b.v.">
            <!-- Ulu BV permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.ulubv"
              :updatePermissions="updateUlubvPermissions"
              :reloadUser="fetchUser"
              brand="ulubv"
            />
          </b-tab>
          <b-tab title="ULU Technologies UK">
            <!-- Ulu uk permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.uluuk"
              :updatePermissions="updateUluukPermissions"
              :reloadUser="fetchUser"
              brand="uluuk"
            />
          </b-tab>
          <b-tab title="Traksi">
            <!-- Ulu uk permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.traksi"
              :updatePermissions="updateTraksiPermissions"
              :reloadUser="fetchUser"
              brand="traksi"
            />
          </b-tab>
          <b-tab title="Requre">
            <!-- Ulu uk permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.requre"
              :updatePermissions="updateRequrePermissions"
              :reloadUser="fetchUser"
              brand="requre"
            />
          </b-tab>
          <b-tab title="Finnik">
            <!-- Ulu uk permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.finnik"
              :updatePermissions="updateFinnikPermissions"
              :reloadUser="fetchUser"
              brand="finnik"
            />
          </b-tab>
          <b-tab title="National Netherlands">
            <!-- NAtional netherlands permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.national_netherlands"
              :updatePermissions="updateNationalNetherlandsPermissions"
              :reloadUser="fetchUser"
              brand="national_netherlands"
            />
          </b-tab>
          <b-tab title="iMoto">
            <!-- Imoto permissions -->
            <ulu-brand-permissions
              class="mb-5"
              :permissions="permissions.imoto"
              :updatePermissions="updateImotoPermissions"
              :reloadUser="fetchUser"
              brand="imoto"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    "ulu-brand-permissions": () =>
      import("@/components/permissions/edit_permissions/BrandPermissions")
  },
  data() {
    return {
      user: {},
      permissions: {
        ulu: null,
        cartracker: null,
        fleetify: null,
        ulubv: null,
        uluuk: null,
        traksi: null,
        requre: null,
        finnik: null,
        national_netherlands: null,
        imoto: null
      }
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    updateUluPermissions(obj) {
      this.permissions.ulu = obj;
    },
    updateCartrackerPermissions(obj) {
      this.permissions.cartracker = obj;
    },
    updateFleetifyPermissions(obj) {
      this.permissions.fleetify = obj;
    },
    updateUlubvPermissions(obj) {
      this.permissions.ulubv = obj;
    },
    updateUluukPermissions(obj) {
      this.permissions.uluuk = obj;
    },
    updateTraksiPermissions(obj) {
      this.permissions.traksi = obj;
    },
    updateRequrePermissions(obj) {
      this.permissions.requre = obj;
    },
    updateFinnikPermissions(obj) {
      this.permissions.finnik = obj;
    },
    updateNationalNetherlandsPermissions(obj) {
      this.permissions.national_netherlands = obj;
    },
    updateImotoPermissions(obj) {
      this.permissions.imoto = obj;
    },
    fetchUser() {
      const data = {
        query: `
          query  {
            authenticatedUser (id: ${this.$route.params.id}) {
              firstname
              lastname
              email
              user_permissions {
                id
                brand

                inquiries_index
                inquiry_show
                inquiry_create
                inquiry_create_master
                inquiry_edit_price
                inquiry_hard_delete

                orders_index
                order_show
                order_create
                order_complete
                order_terminate
                order_add_connectivity
                order_cancel
                order_item_quantity_edit
                order_add_device
                order_add_item
                order_uncomplete_delete
                order_item_price_edit
                order_note_edit

                order_service_index
                order_service_tab
                order_service_create_replace
                order_service_create_install
                order_service_create_remove
                order_service_edit_request_replace
                order_service_edit_request_install
                order_service_edit_request_remove

                invoices_index
                invoice_pause
                invoice_resume
                invoice_paid
                invoice_exact_import
                invoice_exact_export
                invoice_resend
                invoice_edit_note

                customers_index
                customer_show
                customer_create
                customer_block_streatus
                customer_set_web_app_id

                permissions_index
                permissions_show
                permissions_edit

                price_list_index
                price_list_show
                price_list_edit

                credit_create

                device_actions
                devices_index
                device_transfer

                installations_index
                installation_request

                kpi_devices
                kpi_finance
                super_admin

                import_tool
                create_device_event
                create_device_event_custom_agent
                synatec_orders_index
                synatec_order_create
                synatec_order_edit
                synatec_order_request
                manage_synatec_products
                customers_merge
              }
            }
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.user = res.authenticatedUser;
            res.authenticatedUser.user_permissions.forEach(el => {
              switch (el.brand) {
                case "ulu":
                  this.permissions.ulu = el;
                  break;
                case "cartracker":
                  this.permissions.cartracker = el;
                  break;
                case "fleetify":
                  this.permissions.fleetify = el;
                  break;
                case "ulubv":
                  this.permissions.ulubv = el;
                  break;
                case "uluuk":
                  this.permissions.uluuk = el;
                  break;
                case "traksi":
                  this.permissions.traksi = el;
                  break;
                case "requre":
                  this.permissions.requre = el;
                  break;
                case "finnik":
                  this.permissions.finnik = el;
                  break;
                case "national_netherlands":
                  this.permissions.national_netherlands = el;
                  break;
                case "imoto":
                  this.permissions.imoto = el;
                  break;
              }
            });
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  mounted() {
    this.fetchUser();
  },
  created() {
    if (!this.getUserBrandPermissions.permissions_show) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>

<style scoped>
.card-height {
  min-height: 130px;
}

.logo {
  height: 2.5em;
  margin-bottom: 1em;
}
</style>
